export const FilterState = {
    NONE: "NONE",
    LIMITED: "LIMITED",
    ALL: "ALL",
    CONTACTS: "CONTACTS",
    GROUPS: "GROUPS",
    EVENTS: "EVENTS",
    ARTICLES: "ARTICLES",
};